module.exports = "/work-site/img/performance.80f16848.png";